import { Injectable } from '@tanbo/vue-di-plugin'
import { Http } from '@/services/http'
import { InvokeThrottle } from '@/common/decorators/invoke-throttle'
import { ParamsClean } from '@/common/decorators/params-clean'

export interface QueryParams {
  /** 页码（最小页码：1） */
  page: number
  /** 每页数量 */
  limit: number
  /** 排序,true-正序，false-倒序 */
  asc?: boolean
  /** 排序字段（端口号：port_num,终端数量：device_total） */
  sort?: string
  /** 是否风险端口 0->全部，1->风险，2->未知 */
  is_risk_port?: number
  /** 搜索关键字 */
  key_word?: string
  /** 系统类型,0-全部，1-windows,2-linux，3-windows server，4-mac */
  system_type?: number
}

export interface PortItem {
  /** 端口号 */
  port_num: number
  /** 协议 */
  protocol: string
  /** 监听的进程名 */
  process_name: string
  /** 绑定IP */
  bind_ip?: string
  /** 终端数量 */
  device_count?: number
  /** 风险参考（是否已知：0->未知，1->已知） */
  is_known_risk?: number|boolean
  /** 风险参考（详情说明） */
  risk_detail?: string
  /** 系统类型 1-windows 2-linux */
  system_type: number
}

export interface BlockRuleParams {
  /** 选择类型,0-指定终端，1-指定分组, 2-指定端口的全部终端 */
  select_type: number
  /** 端口阻断起点 */
  port_start: number
  /** 端口阻断终点, 起点终点相同时表示只阻断一个端口 */
  port_end: number
  /** 终端设备id列表 */
  device_list?: string[]
  /** 分组id */
  group_id?: number
  /** 系统类型 1-windows 2-linux 3-win server 4-mac */
  system_types: number[]
  port_list:Port[]
}
export interface Port{
   /** 端口号 */
  port: number
  /** 系统类型,0-全部，1-windows,2-linux，3-windows server，4-mac */
  system_type: number
}

@Injectable()
export class PortViewService {
  constructor (private http: Http) {
  }

  @ParamsClean()
  @InvokeThrottle()
  getPortList (data: QueryParams) {
    return this.http.post<{
      /** 端口列表 */
      list: PortItem[]
      /** 总数 */
      total: number
    }>('/portcontrol/port/list', data)
  }

  @InvokeThrottle()
  addBlockRule (data: BlockRuleParams) {
    return this.http.post<void>('/portcontrol/blocked-rule/save', data)
  }
}
